import script from "./BannerTopPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTopPage.vue?vue&type=script&setup=true&lang=js"

import "./BannerTopPage.vue?vue&type=style&index=0&id=5483fb29&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5483fb29"]])

export default __exports__